import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import toast from 'react-hot-toast'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'
import {BASE_URL} from '../../config'
import axios from 'axios'
import {useMutation} from 'react-query'
import ReCAPTCHA from 'react-google-recaptcha'
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'
import HCaptchaComponent from './HCaptchaComponent'
import {siteKey} from '../../../App'

const RESET_PASS_VIA_NUMBER = `${BASE_URL}/api/resetPasswordViaMobileNumber`

const initialValues = {
  number: '',
}

// const forgotPasswordSchema = Yup.object().shape({
//   number: Yup.string()
//     .test(
//       'valid-length',
//       'Provide a valid number (must be 11 or 13 characters)',
//       (value) => value?.length === 11 || value?.length === 13
//     )
//     .required('Mobile number is required'),
// })

const forgotPasswordSchema = Yup.object().shape({
  number: Yup.string()
    .required('Mobile number or email is required')
    .test('is-valid', 'Provide a valid mobile number (11) or a valid email', (value) => {
      if (!value) return false

      // check if it's a valid email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (emailRegex.test(value)) return true

      // check if it's a valid number (11 or 13 digits)
      const numberOnly = value.replace(/\D/g, '') // remove non-digits
      return numberOnly.length === 11
    }),
})

const sendOtpViaNumber = async ({
  mobileNumber,
  captchaToken,
}: {
  mobileNumber: string
  captchaToken: string
}) => {
  const response = await axios.post(
    RESET_PASS_VIA_NUMBER,
    {},
    {
      params: {
        mobileNumber,
        captchaResponse: captchaToken,
      },
    }
  )
  return response.data
}

export function ForgotPassword() {
  const navigate = useNavigate()
  const [token, setToken] = useState('')

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        console.log(values)
        toast.loading('Processing..')

        mutate({mobileNumber: values.number, captchaToken: token})
      } catch (error) {
        toast.dismiss()
        const message = handleAxiosError(error)
        toast.error(message)
        setSubmitting(false)
      }
    },
  })

  const {isLoading, mutate, error} = useMutation({
    mutationFn: sendOtpViaNumber,
    onSuccess: (data, variables) => {
      console.log(data)
      toast.dismiss()
      toast.success(data.message || 'OTP send please check you phone/email')
      navigate(`/auth/forgot-password/${formik.values.number}`)
    },
    onError: (error: Error) => {
      console.log(error)
      toast.dismiss()
      toast.error(handleAxiosError(error))
    },
  })

  const justgo = () => navigate(`/auth/forgot-password/${formik.values.number}`)

  const onHandleCaptcha = (token: string) => {
    setToken(token)
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Forgot Password ?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-700 fw-semibold fs-6'>
          Enter your number/email to reset your password.
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Title */}
      {error && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>
            Sorry, looks like there are some errors detected, please try again.
          </div>
        </div>
      )}

      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>Mobile Number/Email</label>
        <input
          type='text'
          placeholder='Enter number/email'
          autoComplete='off'
          {...formik.getFieldProps('number')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.number && formik.errors.number},
            {
              'is-valid': formik.touched.number && !formik.errors.number,
            }
          )}
        />
        {formik.touched.number && formik.errors.number && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.number}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      <div className='my-5'>
        <HCaptchaComponent siteKey={siteKey} onVerify={onHandleCaptcha} />
      </div>

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn btn-primary me-4'
          disabled={isLoading}
        >
          <span className='indicator-label'>Submit</span>
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Cancel
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
